import { MapTo } from '@adobe/aem-react-editable-components';
import React, { Component } from 'react';
//import { isMobileApp } from '../../utils/api';

export const SpaExperienceFragmentEditConfig = {
  emptyLabel: 'Spa Experience Fragment',
  isEmpty: function(props) {
    return !props || !props.fragmentVariationPath || props.fragmentVariationPath.trim().length < 1;
  },
};

class SpaExperienceFragment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      xfContent: props.html
        ? props.html.substring(props.html.indexOf('<body class="xf-web-container">') + 31, props.html.indexOf('</body'))
        : 'SPA Experience Fragment Not found',
    };
  }

  render() {
    const { xfContent } = this.state;

    return <>{<div dangerouslySetInnerHTML={{ __html: xfContent }} />}</>;
  }
}

export default MapTo('workplace-profile/components/spaexperiencefragment')(
  SpaExperienceFragment,
  SpaExperienceFragmentEditConfig,
);
